import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select'
import Paginate from "vuejs-paginate";
import PageTracker from '../../../common/PageTrackerHelper';
import moment from 'moment';
import keycloak from '../../../common/Keycloak';

export default {
    name: 'IvrCallDetails',
    components: { BasicSelect, VueElementLoading, Paginate },
    props: [],
    mixins: [PageTracker],
    data() {
        return {
            isLoding: false,
            isTableLoading: false,
            deliveryUser: '',
            singleDeliveryObj: { value: '', text: '' },
            deliveryUserList: [],
            shippingId: '',
            filterDate: null,
            createdBy: null,
            userid: null,
            userHubId: 0,
            ivrCallData: [],
            pagecount: 0,
            limit: 10,
            pageno: 1,
            tableShow: false,
            maxToDateFilter: new Date().toISOString().slice(0, 10),
            todayDate: new Date().toISOString().slice(0, 10),
            dateTimeISTFormat: null,
            dateISTFormat: null,
            userDataKey : '',
        }
    },
    created: function () {
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        let userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        let plaintext = bytes.toString(CryptoJS.enc.Utf8);
        let userdetail = JSON.parse(plaintext)
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];
        this.getDeliveryUserList();
        this.filterDate = this.todayDate;
    },
    methods: {
        async selectDeliveryUser(obj) {
            this.isLoding = true;
            this.singleDeliveryObj = obj;
            this.deliveryUser = obj.value;
            this.isLoding = false;
        },
        onEnteredShippingId(evt) {
            if (this.shippingId) {
                let letters = /^[[a-zA-Z0-9]+$/;
                this.shippingId = this.shippingId.trim();
                let isValid = letters.test(this.shippingId)
                if (isValid) {
                } else {
                    if (!this.deliveryUser) {
                    }
                }
            } else {
                if (!this.deliveryUser) {
                }
            }
        },
        async getDeliveryUserList() {
            this.isLoding = true;
            let requestPayload = {
                "usertype": "3",
                "hubid": [this.userHubId]
            };
            let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
            if (keycloak.enableKavach) {
                apiendpoint = 'user/migration/gethubdeliveryuserlist';
            }
            await axios({
                method: 'POST',
                url: apiUrl.api_url + apiendpoint,
                data: requestPayload

            }).then(result => {
                if (result.data.data.code == 200) {
                    let deliveryUserList = result.data.data.results;
                    deliveryUserList.map(datacheck => {
                        let deliveryObject = {
                            value: datacheck.userid,
                            text: `${datacheck.FirstName} ${datacheck.LastName} (${datacheck.OldDeliveryUserOrUserId}) (${datacheck.userid})`
                        };
                        this.deliveryUserList.push(deliveryObject);
                    });
                } else {
                    let errorMessage = (result.data.data.message ? result.data.data.message : 'SR list not available');
                    this.$alertify.error(errorMessage);
                }
                this.isLoding = false;
            }).catch(error => {
                this.isLoding = false;
                this.$alertify.error(error.message);
            });
        },
        async getIverCallDetails(event = {}) {
            this.tableShow = true;
            this.isTableLoading = true;
            this.ivrCallData = [];
            let recordCount = 0;

            /** This condition added for after rending we searching specific shipment data*/
            if (event.type) {
                this.pagecount = 0;
                this.$refs.paginate.selected = 0
                this.pageno = 1;
            }

            let reqPayload = {
                deliveryuserid: this.deliveryUser,
                shippingid: this.shippingId,
                filterdate: this.filterDate,
                hubid: this.userHubId,
                limit: this.limit,
                offset: this.pageno
            };
            await axios({
                method: 'POST',
                url: apiUrl.api_url + 'ivr/getcalldetails',
                data: reqPayload

            }).then(result => {
                if (result.data.code == 200) {
                    recordCount = result.data.data.count;
                    this.ivrCallData = result.data.data.rows;
                    if (recordCount < this.limit) {
                        this.pagecount = 1;
                    } else {
                        this.pagecount = Math.ceil(recordCount / this.limit)
                    }
                } else {
                    this.pagecount = 0;
                    recordCount = 0;
                    this.ivrCallData = [];
                    let errorMessage = (result.data.message ? result.data.message : 'Ivr call details not found');
                    this.$alertify.error(errorMessage);
                }
                this.isTableLoading = false;
            }).catch(error => {
                this.isTableLoading = false;
                this.$alertify.error(error.message);
            });

        },
        async getPaginationData(pageNum) {
            this.pageno = pageNum;
            // if (1 >= pageNum) {
            //     this.pageno = 0;
            // } else {
            //     this.pageno = pageNum;
            // }
            this.getIverCallDetails();
        },
        ResetSearchForm() {
            this.tableShow = false;
            this.deliveryUser = '';
            this.singleDeliveryObj = { value: '', text: '' };
            this.pagecount = 0;
            this.pageno = 1;
            this.ivrCallData = [];
            this.shippingId = '';
            this.isLoding = false;
            this.isTableLoading = false;
            this.filterDate = this.todayDate;
        }
    },
    filters: {
        dateTimeISTFormat: function (dateTime) {
            if (!dateTime)
                return '--'
            return moment(dateTime).utc().utcOffset("05:30").format('DD-MM-YYYY HH:mm:ss');
        },
        dateISTFormat: function (date) {
            if (!date)
                return '--'
            return moment(date).format('DD-MM-YYYY');
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/IvrCallDetails/IvrCallDetail.component.js